"use client";

import React from "react";
import Image from "next/image";
// import profiili from "../../public/images/tapsa.jpg";
import { SoftGradientBackground } from "@/components/ui/soft-gradient";

// Types
interface AboutSectionProps {
    title: string;
    children: React.ReactNode;
}

// Reusable Components
const AboutSection = ({ title, children }: AboutSectionProps) => (
    <section className="space-y-4">
        <h2 className="font-bold italic text-xl md:text-2xl text-gray-900 dark:text-white">
            {title}
        </h2>
        <div className="space-y-4">{children}</div>
    </section>
);

const aboutContent = { introduction: "Hello, " };

// Main Component
export function AboutMe() {
    return (
        <SoftGradientBackground>
            <div className="relative flex flex-col gap-8 items-center justify-center min-h-screen pt-24 pb-24 px-4 sm:px-6 lg:px-8 container mx-auto">
                <div className="relative z-10 bg-white/60 dark:bg-neutral-800/15 p-6 py-12 md:p-8 md:py-20 rounded-xl shadow-2xl border-2 border-white/60 dark:border-neutral-800/60 backdrop-blur-sm w-full sm:w-3/4 lg:w-2/3 max-w-4xl">
                    {/* Main Title */}
                    <header className="text-center mb-12">
                        <h1 className="text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-gray-900 dark:text-white">
                            About Me
                        </h1>
                    </header>

                    {/* Content */}
                    <div className="font-serif text-sm md:text-base lg:text-lg text-gray-900 dark:text-neutral-100 leading-relaxed space-y-8 md:space-y-10 antialiased tracking-wide text-left">
                        {/* Introduction */}
                        <p className="text-center md:text-left text-base md:text-lg lg:text-xl">
                            {aboutContent.introduction}
                        </p>

                        {/* Professional Background */}
                        <AboutSection title={""}>
                            <p>I&apos;m Tapio Meriläinen, an expert on the field of computer science.</p>
                            <p>
                                Recently, I have done mostly audio related machine learning for my thesis. Although, I enjoy designing websites when time allows. Both Viso and Porokylankuntoutus websites were made entirely by me.
                            </p>
                            <p>
    Drone detection was a fascinating and ethically rewarding area for a master&apos;s thesis. In addition, my previous background in audiovisual communications became useful &ndash; since I recognized a lot of the terminology and methods I had to use in acoustical drone detection, the thesis study was rewarding in both experience and results. I hope to present my work in the future via conference proceedings. The Finnish thesis is available at{" "}
    <a 
        href="https://erepo.uef.fi/items/1181e810-6d83-47ff-a2df-a7b8df7114c1" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-blue-600 dark:text-blue-400 underline hover:no-underline"
    >
        https://erepo.uef.fi/items/1181e810-6d83-47ff-a2df-a7b8df7114c1
    </a>
</p>
                        </AboutSection>
                    </div>
                </div>
            </div>
        </SoftGradientBackground>
    );
}
